const NEWSLETTER_RESULT = Object.freeze({
    SUCCESS: 'success',
    INVALID_EMAIL: 'invalid',
    ERROR: 'error',
});

export default NEWSLETTER_RESULT;
